/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmailMatchRule } from './EmailMatchRule';
import {
    EmailMatchRuleFromJSON,
    EmailMatchRuleFromJSONTyped,
    EmailMatchRuleToJSON,
    EmailMatchRuleToJSONTyped,
} from './EmailMatchRule';

/**
 * 
 * @export
 * @interface ListEmailMatchRulesResponse
 */
export interface ListEmailMatchRulesResponse {
    /**
     * 
     * @type {Array<EmailMatchRule>}
     * @memberof ListEmailMatchRulesResponse
     */
    rules: Array<EmailMatchRule>;
}

/**
 * Check if a given object implements the ListEmailMatchRulesResponse interface.
 */
export function instanceOfListEmailMatchRulesResponse(value: object): value is ListEmailMatchRulesResponse {
    if (!('rules' in value) || value['rules'] === undefined) return false;
    return true;
}

export function ListEmailMatchRulesResponseFromJSON(json: any): ListEmailMatchRulesResponse {
    return ListEmailMatchRulesResponseFromJSONTyped(json, false);
}

export function ListEmailMatchRulesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListEmailMatchRulesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'rules': ((json['rules'] as Array<any>).map(EmailMatchRuleFromJSON)),
    };
}

export function ListEmailMatchRulesResponseToJSON(json: any): ListEmailMatchRulesResponse {
    return ListEmailMatchRulesResponseToJSONTyped(json, false);
}

export function ListEmailMatchRulesResponseToJSONTyped(value?: ListEmailMatchRulesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rules': ((value['rules'] as Array<any>).map(EmailMatchRuleToJSON)),
    };
}

